import * as React from 'react';
import { bindActionCreators, Dispatch, compose } from 'redux';
import { connect } from 'react-redux';

import { IStore } from '../../modules/root-reducer';
import { Editable } from '../../@types';
import * as actions from '../../modules/popup/action';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import {
  WithStyles,
  withStyles,
  Theme,
  createStyles
} from '@material-ui/core/styles';

const styles = ({ spacing }: Theme) =>
  createStyles({
    button: {
      margin: spacing.unit
    }
  });

interface IDeleteDialogProps {
  entity: Editable;
  deleteEntity: (id?: number) => void;
  title: string;
  prompt: JSX.Element;
}

const DeleteDialog = (
  props: IDeleteDialogProps &
    WithStyles<typeof styles> &
    IStateProps &
    IDispatchProps
) => {
  const {
    classes,
    dialogOpen,
    closeDeleteDialog,
    entity,
    deleteEntity,
    title,
    prompt,
    ...other
  } = props;

  const handleDelete = () => {
    deleteEntity(entity.id);
    closeDeleteDialog();
  };

  return (
    <Dialog open={dialogOpen} onClose={closeDeleteDialog} {...other}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {prompt}
        <Button
          onClick={closeDeleteDialog}
          variant="contained"
          color="default"
          className={classes.button}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          style={{ backgroundColor: '#D32F2F', color: '#FFF' }}
          className={classes.button}
        >
          Delete
        </Button>
      </DialogContent>
    </Dialog>
  );
};

interface IStateProps {
  dialogOpen: boolean;
}

const mapStateToProps = (state: IStore) => {
  return {
    dialogOpen: state.popupReducer.deleteDialogOpen
  };
};

interface IDispatchProps {
  closeDeleteDialog: () => actions.ICloseDeleteDialog;
}

const mapDispatchToProps = (dispatch: Dispatch<actions.PopupAction>) => {
  return bindActionCreators(
    { closeDeleteDialog: actions.closeDeleteDialog },
    dispatch
  );
};

const enhance = compose(
  connect<IStateProps, IDispatchProps, IDeleteDialogProps, IStore>(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
);

export default enhance(DeleteDialog);



// WEBPACK FOOTER //
// ./src/common/delete-dialog/delete-dialog.tsx